<template>
    <div class="grid tw-row" style="margin: 0;" :class="[
        {
            'grid-nogutter': !gutter
        }]">
        <slot name="default"></slot>
    </div>
</template>

<script>
export default {
    name: 'tw-row',
    props: {
        gutter: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style>

</style>